import { Pipe, PipeTransform } from '@angular/core';
import { formatDuration } from './utils/duration.utils';

@Pipe({
  name: 'duration',
  pure: true,
})
export class DurationPipe implements PipeTransform {
  transform(value: number): string {
    return formatDuration(value);
  }
}
